export default "__VITE_ASSET__1sEnzyz4__"